import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import { 
  getFillTemplates, 
  getFillTemplate, 
  createFillTemplate, 
  updateFillTemplate, 
  deleteFillTemplate,
  clearLocalFillTemplates,
  clearLocalActiveFillTemplate
} from "./actions";

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  fillTemplate: { 
    id: '', 
    created_at: '', 
    updated_at: '', 
    template: { id: '', name: '', file: null, pages: [], elements: [], pages_count: 0, created_at: '', updated_at: '' } 
  },
  loading: { 
    all: false, 
    fillTemplate: false 
  }
};

const  slice = createSlice({
  name: 'fillTemplates',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getFillTemplates.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getFillTemplates.fulfilled, (state, action) => {
        const { fill_templates, pagination } = action.payload;

        state.loading.all = false;
        state.all = { ...state.all, data: [...state.all.data, ...fill_templates], pagination };
      })
      .addCase(getFillTemplates.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getFillTemplate.pending, (state) => {
        state.loading.fillTemplate = true;
      })
      .addCase(getFillTemplate.fulfilled, (state, action) => {
        const { fill_template } = action.payload;
        const data = _map(state.all.data, (item) => item.id === fill_template.id ? { ...item, ...fill_template } : item);
        const updatedFillTemplate = { ...state.fillTemplate, ...fill_template };

        state.loading.fillTemplate = false;
        state.all = { ...state.all, data };
        state.fillTemplate = updatedFillTemplate;
      })
      .addCase(getFillTemplate.rejected, (state) => {
        state.loading.fillTemplate = false;
      })
      .addCase(createFillTemplate.pending, (state) => {
        state.loading.fillTemplate = true;
      })
      .addCase(createFillTemplate.fulfilled, (state, action) => {
        const { fill_template } = action.payload;
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = [...[fill_template], ...oldAllData];
        const pagination = { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.fillTemplate = false;
        state.all = { ...state.all, data, pagination };
        state.fillTemplate = { ...state.fillTemplate, fill_template };
      })
      .addCase(createFillTemplate.rejected, (state) => {
        state.loading.fillTemplate = false;
      })
      .addCase(updateFillTemplate.pending, (state) => {
        state.loading.fillTemplate = true;
      })
      .addCase(updateFillTemplate.fulfilled, (state, action) => {
        const { status, fillTemplate } = action.payload;
        const updatedFillTemplate = { ...state.fillTemplate, ...fillTemplate };
        const data = _map(state.all.data, (item) => item.id === fillTemplate.id ? { ...item, ...fillTemplate } : item);

        state.loading.fillTemplate = false;
        if (status === 204) {
          state.all = { ...state.all, data };
          state.fillTemplate = updatedFillTemplate;
        }  
      })
      .addCase(updateFillTemplate.rejected, (state) => {
        state.loading.fillTemplate = false;
      })
      .addCase(deleteFillTemplate.pending, (state) => {
        state.loading.fillTemplate = true;
      })
      .addCase(deleteFillTemplate.fulfilled, (state, action) => {
        const { status, id } = action.payload;
        const data = _filter(state.all.data, (item) => item.id !== id);
        const pagination = { ...state.all.pagination, count: state.all.pagination.count - 1, total_count: state.all.pagination.total_count - 1 };
        
        state.loading.fillTemplate = false;
        if (status === 204) {
          state.all = { data, pagination };
        }
      })
      .addCase(deleteFillTemplate.rejected, (state) => {
        state.loading.fillTemplate = false;
      })
      .addCase(clearLocalFillTemplates, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveFillTemplate, state => {
        state.fillTemplate = initialState.fillTemplate;
      })
  }
})

export default slice.reducer;